import { NavBarStateAction } from "./action";
import { NavBarState,initNavBarState} from "./state";


export function NavBarStateReducer(state:NavBarState = initNavBarState,action:NavBarStateAction):NavBarState{
    switch(action.type){
        case '@@NavBarAction/initNavBarAction':
            return {
                ...state,
                navList:action.state
            }
        case '@@NavBarAction/moveToOtherNavigationBarAction':
            return {
                ...state,
                page:action.page,
                pageIndex:action.index
            }

        case '@@NavBarAction/ChangeSurveyPageAction':
            return {
                ...state,
                surveyPage:action.surveyPage
            }
        case '@@NavBarAction/changePageWithDetailThunkAction':
            return{
                ...state,
                page:action.page,
                pageIndex:action.index,
                nav_bar_detail:action.nav_bar_detail
            }
    

        default:
            return state
    }
}


